export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/get-app-booking.8b2c6ce3.svg","height":110,"width":97,"blurWidth":0,"blurHeight":0};